import React from 'react';
import { useNodesStore } from '../../../store/storeNodesEdeges';
import { useVersionControlStore } from '../../../store/storeVersionControl';
import { XCircle } from '@phosphor-icons/react';
type Props = {
  nodeId: string;
  color?: string;
};

const DeleteNode = ({ nodeId, color = '#667085' }: Props) => {
  const setDelete = useNodesStore(state => state.setDeleteNode);
  const isProductionView = useVersionControlStore(state => state.isProductionView);

  if (isProductionView) return null;

  return (
    <XCircle
      style={{
        cursor: 'pointer',
      }}
      color={color}
      size={20}
      onClick={() => setDelete(nodeId)}
    >
      X
    </XCircle>
  );
};

export default DeleteNode;
